// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorShippingOptions = (client) => ({
    /**
     * `POST /vendor/shipping-options`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreateShippingOption
     * @source packages/modules/b2c-core/src/api/vendor/shipping-options/route.ts
     */
    create: (body, query, headers) => client.fetch("/vendor/shipping-options", { method: "POST", body, query, headers }),
    /**
     * `DELETE /vendor/shipping-options/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorDeleteShippingOptionById
     * @source packages/modules/b2c-core/src/api/vendor/shipping-options/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/vendor/shipping-options/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /vendor/shipping-options`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListShippingOptions
     * @source packages/modules/b2c-core/src/api/vendor/shipping-options/route.ts
     */
    list: (query, headers) => client.fetch("/vendor/shipping-options", { method: "GET", query, headers }),
    /**
     * `GET /vendor/shipping-options/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetShippingOptionById
     * @source packages/modules/b2c-core/src/api/vendor/shipping-options/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/vendor/shipping-options/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/shipping-options/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdateShippingOptionById
     * @source packages/modules/b2c-core/src/api/vendor/shipping-options/[id]/route.ts
     */
    update: (id, body, query, headers) => client.fetch(buildPath("/vendor/shipping-options/:id", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=shipping-options.js.map